// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ea0dae9","239":"6809dac8","455":"662e23b2"}[chunkId] + ".chunk.js";
};